import React from 'react';

const BellIcon = ({ color = 'currentColor', size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    <path d="M12 22c1.104 0 2-.896 2-2h-4c0 1.104.896 2 2 2zm6.707-5.293l-1.414-1.414c-.63-.63-.707-1.707-.707-2.293v-5c0-3.314-2.686-6-6-6s-6 2.686-6 6v5c0 .586-.077 1.663-.707 2.293l-1.414 1.414c-.63.63-.707 1.707-.707 2.293h18c0-.586-.077-1.663-.707-2.293zM18 18h-12v-1.586l1.293-1.293c.63-.63.707-1.707.707-2.293v-5c0-2.206 1.794-4 4-4s4 1.794 4 4v5c0 .586.077 1.663.707 2.293l1.293 1.293v1.586z"/>
  </svg>
);

export default BellIcon;
